import { render } from "./MultipleInput.vue?vue&type=template&id=4f5a7974&scoped=true"
import script from "./MultipleInput.vue?vue&type=script&lang=js"
export * from "./MultipleInput.vue?vue&type=script&lang=js"

import "./MultipleInput.vue?vue&type=style&index=0&id=4f5a7974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5a7974"]])

export default __exports__